import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormikProps } from 'formik';
import {
    REDIRECT_AREA,
    REDIRECT_AREA_DETAIL,
} from '../../../../../routes/paths';
import {
    asyncGetParam,
    asyncGetRedirectAreaHistorical,
    asyncPatchRedirectAreaParam,
    asyncPostRedirectAreaParam,
} from '../../../../../services/param.service';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';
import { Param, ParamHistorical } from '../../../../../shared/types/param';

export const useRedirectAreaForm = () => {
    const navigate = useNavigate();
    const { idRedirectArea } = useParams();
    const [redirectArea, setRedirectArea] = useState<Param>();
    const [loading, setLoading] = useState(false);
    const [formikRedirectAreaData, setFormikRedirectAreaData] =
        useState<FormikProps<Param>>();
    const [showHistorical, setShowHistorical] = useState(false);
    const [redirectAreaHistorical, setRedirectAreaHistorical] =
        useState<ParamHistorical[]>();

    const isValidForm = formikRedirectAreaData?.isValid;

    const handleCleanAndBack = () => {
        formikRedirectAreaData?.resetForm();
        navigate(REDIRECT_AREA);
    };

    const handleSubmit = async () => {
        await formikRedirectAreaData?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: Param = formikRedirectAreaData?.values;

        let res: any | undefined = undefined;

        try {
            if (redirectArea && redirectArea.id)
                res = await asyncPatchRedirectAreaParam(redirectArea.id, data);
            else res = await asyncPostRedirectAreaParam(data);
        } catch (error) {}
        if (res?.items) {
            const item = Array.isArray(res?.items) ? res?.items[0] : res?.items;
            ToastSwal.fire({
                text: `¡Felicidades! el área de redirección se ${
                    redirectArea && redirectArea.id ? 'actualizo' : 'creó'
                } satisfactoriamente.`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(`${REDIRECT_AREA_DETAIL}/${item.id}`);
        } else {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo ${
                    redirectArea && redirectArea.id ? 'actualizar' : 'crear'
                } el área de redirección. Por favor, asegúrate de ${
                    redirectArea && redirectArea.id
                        ? 'diligenciar los datos correctamente'
                        : 'que no exista previamente'
                } e intenta nuevamente más tarde.`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    useEffect(() => {
        if (Boolean(idRedirectArea)) {
            setLoading(true);
            asyncGetParam(idRedirectArea)
                .then((redirectArea: any) => {
                    if (!redirectArea || !redirectArea.items)
                        navigate(REDIRECT_AREA);
                    setRedirectArea(redirectArea?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idRedirectArea]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetRedirectAreaHistorical(idRedirectArea)
                .then((resp) => {
                    if (resp) setRedirectAreaHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        redirectArea,
        loading,
        isValidForm,
        handleSubmit,
        handleCleanAndBack,
        setFormikRedirectAreaData,
        redirectAreaHistorical,
        showHistorical,
        setShowHistorical,
    };
};
